import { Worker } from "types/generated";
import { AccessResult } from "utils/access";

const canDrainWorker = (worker: Worker): boolean => {
  return !worker.drained;
};

const canUndrainWorker = (worker: Worker): boolean => {
  return worker.drained;
};

export const canDrainWorkerWithPoolAccess = (worker: Worker, poolAccess: AccessResult): AccessResult => {
  if (!canDrainWorker(worker)) {
    return { result: false };
  }
  return poolAccess;
};

export const canUndrainWorkerWithPoolAccess = (worker: Worker, poolAccess: AccessResult): AccessResult => {
  if (!canUndrainWorker(worker)) {
    return { result: false };
  }
  return poolAccess;
};
